import React from 'react';
import { Input, Flex, Text, TextArea, Select, Option, DurationInput } from '@pega/cosmos-react-core';
import { InteractiveText } from '../../../Utilities/custom.styled';
import useLocalTranslation from '../../../../hooks/useLocalTranslation';

function EditProactiveMessaging() {
  const translate = useLocalTranslation();

  return (
    <Flex
      container={{
        direction: 'column',
        itemGap: 1,
      }}
    >
      <Input name="name" label="Name" type="text" required={true} />

      <TextArea name="Message" type="text" label="Message" required={true} />
      <Select label="When to engage">
        <Option>Time spent on page</Option>
      </Select>
      <DurationInput label="Time" required value={42000} />
      <Text>{translate('copy_below_snippet_for_proactive')}</Text>
      <TextArea label="Code" value={``} />
      <InteractiveText>{translate('copy_code_snippet')}</InteractiveText>
    </Flex>
  );
}

export default EditProactiveMessaging;
